import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import { NS, U3202ROLES } from '../../U3202';

interface U3202OrgProviderConfigListEmptyProps {
  onAddConfig?: () => void;
}

const U3202OrgProviderConfigListEmpty: React.FC<U3202OrgProviderConfigListEmptyProps> = ({
  onAddConfig,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();
  const canAct = hasRole(U3202ROLES.EDIT);

  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-10 text-center">
      <p className="max-w-lg text-sm text-muted-foreground">{t('configList.empty', { ns: NS })}</p>
      {canAct && onAddConfig && (
        <U2000ActionBtn
          label={t('configList.addProvider', { ns: NS })}
          handleClick={onAddConfig}
          icon={FaPlus}
        />
      )}
    </div>
  );
};

export default U3202OrgProviderConfigListEmpty;
